export default "__VITE_ASSET__cf9a20f9__"